import { ChangeEvent, ReactNode } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

interface CheckboxProps {
    checked: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    label?: string | ReactNode;
    [key: string]: unknown;
}

const CheckboxInputComponent = ({
    checked,
    onChange,
    error,
    label,
    ...props
}: CheckboxProps) => {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    color="primary"
                    sx={{
                        borderColor: error ? 'red !important' : 'transparent'
                    }}
                    {...props}
                />
            }
            sx={{
                whiteSpace: 'nowrap'
            }}
            label={label}
        />
    );
};

export default CheckboxInputComponent;